import { CardLoader } from 'components/organisms'
import CommissionPagination from 'domains/seller-product-commission/organisms/pagination'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'
import CommissionTableRow from './commission-table-row'

const propTypes = {
  tableProps            : PropTypes.object,
  commissions           : PropTypes.array,
  pagination            : PropTypes.object,
  onPageChange          : PropTypes.func,
  isLoading             : PropTypes.bool,
  onClickChangeIsActive : PropTypes.func,
  onClickUpdate         : PropTypes.func
}

const defaultProps = {
  isLoading: false
}

/**
 * Table to display specific ::SellerProductCommission columns
 * @param {Array<Object>} data - array of commission objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onPageChange - function that will handle Page Change
 * @param {Boolean} isLoading - boolean for withLoader animation
 */

const CommissionTable = ({
  tableProps,
  commissions,
  pagination,
  isLoading,
  onPageChange,
  onClickUpdate,
  onClickChangeIsActive
}) => {

  const totalColumns      = 11
  const isCommissionEmpty = commissions.length === 0

  const TableContent = () => (
    <Table { ...tableProps }>
      <thead>
        <th colSpan={ totalColumns } className='text-center'>
          { 'Commissions' }
        </th>
      </thead>
      <thead>
        <tr>
          <th scope="col">id</th>
          <th scope="col">name</th>
          <th scope="col">price from</th>
          <th scope="col">price to</th>
          <th scope="col">calculation type</th>
          <th scope="col">absolute value</th>
          <th scope="col">percentage</th>
          <th scope="col">contract</th>
          <th scope="col">payable to</th>
          <th scope="col">status</th>
          <th scope="col">action</th>
        </tr>
      </thead>
      <tbody>
        {
          commissions.map((commission) => (
            <CommissionTableRow
              key={ `CommissionTableRow-${commission.id}` }
              commission={ commission }
              onClickUpdate={ onClickUpdate }
              onClickChangeIsActive={ onClickChangeIsActive }
            />
          ))
        }
        {
          isCommissionEmpty && (
            <tr>
              <td
                colSpan={ totalColumns }
                className='bg-warning text-white'
              >
                <i className='fas fa-info-circle mr-3' />
                { 'No Commission found based on your filters.' }
              </td>
            </tr>
          )
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <CommissionPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}


CommissionTable.propTypes    = propTypes
CommissionTable.defaultProps = defaultProps

export default CommissionTable
